import { __awaiter, __generator } from "tslib";
import { useState, useEffect } from 'react';
import { getThreadId } from '../../domain/selectors/get-thread-id';
import { useSelector } from 'react-redux';
import { createDebugLogger } from './app-utils';
var debug = createDebugLogger('ConnectivityCheck');
/**
 * Custom hook which returns true/false if the site is reachable.
 * @param url
 */
export var useIsSiteReachable = function (url, skipCheck) {
    if (skipCheck === void 0) { skipCheck = false; }
    // initial state is true because we assume the site is reachable
    var _a = useState(true), isReachable = _a[0], setIsReachable = _a[1];
    var CHECK_INTERVAL = 3000;
    var isThreadActive = useSelector(getThreadId);
    useEffect(function () {
        var interval = setInterval(function () { return __awaiter(void 0, void 0, void 0, function () {
            var response, error_1;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (skipCheck) {
                            return [2 /*return*/]; // do not check if there is no active thread (limit requests on server)
                        }
                        _a.label = 1;
                    case 1:
                        _a.trys.push([1, 3, , 4]);
                        return [4 /*yield*/, fetch(url, { method: 'HEAD' })];
                    case 2:
                        response = _a.sent();
                        if (response.ok) {
                            debug("setIsReachable(true)");
                            setIsReachable(true);
                        }
                        else {
                            debug("setIsReachable(false)");
                            setIsReachable(false);
                        }
                        return [3 /*break*/, 4];
                    case 3:
                        error_1 = _a.sent();
                        debug("setIsReachable(false),error");
                        setIsReachable(false);
                        return [3 /*break*/, 4];
                    case 4: return [2 /*return*/];
                }
            });
        }); }, CHECK_INTERVAL);
        return function () { return clearInterval(interval); }; // Clean up on unmount
    }, [url, skipCheck]);
    return isReachable;
};
/**
 * Custom hook which returns true/false if the device is online.
 *
 */
export var isDeviceOnline = function () {
    var _a = useState(true), isOnline = _a[0], setIsOnline = _a[1];
    useEffect(function () {
        var goOnline = function () { return setIsOnline(true); };
        var goOffline = function () { return setIsOnline(false); };
        window.addEventListener('online', goOnline);
        window.addEventListener('offline', goOffline);
        // Clean up after the component unmounts
        return function () {
            window.removeEventListener('online', goOnline);
            window.removeEventListener('offline', goOffline);
        };
    }, []);
    debug("isDeviceOnline: ".concat(isOnline));
    return isOnline;
};
/**
 *  Custom hook which returns true/false if the device is online and the site is reachable.
 */
export var useDeviceAndSiteStatus = function (options) {
    var url = options.url, skipReachableCheck = options.skipReachableCheck;
    var isOnline = isDeviceOnline();
    var isSiteReachable = useIsSiteReachable(url, skipReachableCheck);
    var _a = useState(true), status = _a[0], setStatus = _a[1];
    useEffect(function () {
        if (isOnline && isSiteReachable) {
            setStatus(true);
        }
        else {
            setStatus(false);
        }
    }, [isOnline, isSiteReachable]);
    return status;
};
export var isNetworkErrorMessage = function (m) {
    var _a;
    var message = ((_a = m === null || m === void 0 ? void 0 : m.body) === null || _a === void 0 ? void 0 : _a.toLowerCase()) || '';
    var isNetworkError = message.includes('network error');
    var isRequestError = message.includes('request');
    if (isRequestError || isRequestError) {
        return true;
    }
    return false;
};
